import { Button } from '@avanta/shared/components/ui/Button';
import { useDialogContext } from '@avanta/shared/contexts/Dialog';
import { Pencil, Trash2 } from 'lucide-react';
import { type AdminEnterprise } from 'types/enterprises';
import { BanAdministratorDialog } from '../BanAdministratorDialog';
import { EditAdministrator } from '../EditAdministrator';

export const AdministratorActions = ({ admin }: { admin: AdminEnterprise }): React.ReactElement => {
  const { showDialog } = useDialogContext();

  const handleOnEditAdministrator = (): void => {
    showDialog({ component: <EditAdministrator admin={admin} /> });
  };

  const handleOnBanAdministrator = (): void => {
    showDialog({ component: <BanAdministratorDialog adminId={admin.id} /> });
  };

  return (
    <div className="flex gap-2 -ml-3">
      <Button variant="primary_terciary" icon="only" onClick={handleOnEditAdministrator}>
        <Pencil className="size-6" />
      </Button>
      <Button variant="destructive_terciary" icon="only" onClick={handleOnBanAdministrator}>
        <Trash2 className="size-6" />
      </Button>
    </div>
  );
};
